import styled from "styled-components";

export const MessageModal = styled.div`
  > h1 {
    display: flex;
    justify-content: center;
    color: #ffffff;
    font-weight: 550;
    font-size: 1.7rem;
    margin: 18px 0px;
    text-align: center;

    @media (min-width: 480px) {
      font-size: 2.25rem;
      line-height: 45px;
      margin: 30px 0px;
    }

    @media (min-width: 768px) {
      font-size: 1rem;
      line-height: 20px;
      margin: 16px 0px;
    }
  }

  > p {
    text-align: center;
    color: #ffffff;
    font-weight: 500;
    font-size: 1rem;
    line-height: 30px;
    margin: 18px 0px;

    @media (min-width: 480px) {
      font-size: 1.5rem;
      margin: 40px 0px;
    }

    @media (min-width: 768px) {
      font-weight: 550;
      font-size: 0.75rem;
      line-height: 15px;
      margin: 16px 0px;
    }
  }
`;
export const IconsModal = styled.div`
  display: flex;
  justify-content: center;
  position: static;

  .svg__icon {
    height: 45px;
    width: 45px;

    @media (min-width: 480px) {
      height: 57px;
      width: 57px;
    }

    @media (min-width: 768px) {
      height: 30px;
      width: 30px;
    }
  }

  .error-icon {
    color: ${(props) => props.theme.colors.error.medium};
  }
`;
